import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { useLazyReducer } from '@/core/applicationState/hooks/useLazyReducer';
import { useLazySaga } from '@/core/applicationState/hooks/useLazySaga';
import { getDevice } from '@/productDiscovery/Listings/sponsoredProducts/utils/getDevice';
import {
  FETCH_SPONSORED_DATA,
  fetchSponsoredData,
} from '@/productDiscovery/ProductPage/modules/SponsoredData/sponsoredData.actions';

const sponsoredDataSaga = () =>
  import(
    '@/productDiscovery/ProductPage/modules/SponsoredData/sponsoredData.saga'
  ).then((mod) => mod.default);

const sponsoredDataReducer = () =>
  import(
    '@/productDiscovery/ProductPage/modules/SponsoredData/sponsoredData.reducer'
  ).then((mod) => mod.default);

export const useFetchSponsoredData = () => {
  const dispatch = useDispatch();
  const router = useRouter();
  const { sagaInjected } = useLazySaga(
    FETCH_SPONSORED_DATA,
    sponsoredDataSaga,
    { condition: true },
  );

  const { reducerInjected } = useLazyReducer(
    `productDiscovery.productPage.sponsoredData`,
    sponsoredDataReducer,
    { condition: true },
  );

  useEffect(() => {
    if (sagaInjected && reducerInjected) {
      dispatch(
        fetchSponsoredData(getDevice().toUpperCase() as 'DESKTOP' | 'MOBILE'),
      );
    }
  }, [dispatch, reducerInjected, sagaInjected]);

  useEffect(() => {
    const handleRouteChange = () => {
      dispatch(
        fetchSponsoredData(getDevice().toUpperCase() as 'DESKTOP' | 'MOBILE'),
      );
    };
    router.events.on('routeChangeComplete', handleRouteChange);

    return () => {
      router.events.off('routeChangeComplete', handleRouteChange);
    };
  }, [router, dispatch]);
};
